/** Fallback slug when API omits `slug` on activity/location (prefer backend `slug`). */
export function slugFromLabel(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
